import React from 'react';
import { Echarts } from '@tencent/spaui';
import {
  leftChartStyle,
  pieChartLegendStyle,
  multipleColor,
  chartRadius,
} from './index';

const PieChartInner = (props) => {
  let overallData = [];
  let total = 0;
  if (props.overallData && props.overallData.entities && !!props.overallData.entities.length) {
    overallData = props.overallData.entities.map((item) => ({ name: item.label, value: item.value }));
    total = props.overallData.entities.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.value;
    }, 0);
  }
  const option = {
    title: {
      //   text: props.title,
      position: 'center',
      textAlign: 'left',
      left: 'center',
      top: 'center',
      text: `总量 ${total}`,
      textStyle: {
        fontSize: 14,
        fontWeight: 500,
        fontFamiliy: 'PingFang SC',
      },
    },
    tooltip: {
      trigger: 'item',
    },
    legend: pieChartLegendStyle,
    series: [
      {
        name: props.title,
        type: 'pie',
        radius: chartRadius,
        avoidLabelOverlap: true,
        label: {
          normal: {
            show: true,
            distance: 0,
            formatter: '{bStyle|{b}} {cStyle|{c}}\n {dStyle|{d}%}',
            rich: {
              bStyle: {
                fontSize: 12,
                color: '#313233',
              },
              cStyle: {
                fontSize: 14,
                color: '#313233',
              },
              dStyle: {
                fontSize: 12,
                color: '#313233',
                marginBottom: 8,
              },
            },
            alignTo: 'edge',
            margin: 10,
            offset: [0, 0],
            fontSize: 12,
            color: '#313233',
          },
        },
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2,
        },
        data: overallData,
        color: props.pieColor || multipleColor,
        labelLine: {
          length: 15,
        },
        startAngle: 180,
      },
    ],
  };

  return (
    <div className="pie-chart">
      <div className="chart-title">{props.title}</div>
      <Echarts {...option} style={leftChartStyle} />
    </div>
  );
};

export const PieChart = React.memo(PieChartInner);
